/* unplugin-vue-components disabled */import script from "./LoginView.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=ts"

import "./LoginView.vue?vue&type=style&index=0&id=c007baba&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c007baba"]])

export default __exports__